export default __webpack_public_path__ + "media/blueberries-small.db73b9ac045f06feaaac9342e1f8f05c.webp";